import React from "react";
import { Box, Typography } from "@mui/material";

function StatItem({ label, value, accent }) {
  return (
    <Box
      sx={{
        flex: "1 1 120px",
        minWidth: 0,
        p: 2,
        borderRadius: "12px",
        bgcolor: "#fff",
        border: "1px solid #e8eaef",
      }}
    >
      <Typography
        variant="caption"
        sx={{ color: "#9ca3af", fontWeight: 600, letterSpacing: "0.04em", textTransform: "uppercase", fontSize: "0.65rem" }}
      >
        {label}
      </Typography>
      <Typography
        variant="h5"
        sx={{ fontWeight: 700, color: accent || "#111827", mt: 0.5, letterSpacing: "-0.02em" }}
      >
        {value}
      </Typography>
    </Box>
  );
}

export default function EvaluationStats({ total, evaluated, pending, avgScore }) {
  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        gap: 1.5,
        mb: 3,
      }}
    >
      <StatItem label="Técnicos" value={total} />
      <StatItem label="Evaluados" value={evaluated} accent="#059669" />
      <StatItem label="Pendientes" value={pending} accent={pending > 0 ? "#d97706" : "#111827"} />
      <StatItem label="Promedio" value={avgScore > 0 ? `${avgScore}/10` : "—"} accent="#1975d1" />
    </Box>
  );
}
